import styled from "styled-components/macro";

export const Wrapper = styled.div`
  padding: 15rem 25rem;
  display: flex;
  flex-direction: column;
  gap: 25rem;
`;

export const Description = styled.p`
  font-weight: 500;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 10rem;
`;